import { useLocation, useParams } from "react-router";

import { CheckIcon } from "@prequel/shared-components";

import BrandedLogo from "@/components/BrandedLogo";

const REDIRECT_SECONDS = 5;
type LocationState = { redirectUrl: string | undefined };

export const isValidRedirectUrl = (url: string): boolean => {
  try {
    const parsedUrl = new URL(url);
    const scheme = parsedUrl.protocol.toLowerCase();

    // Only allow HTTP and HTTPS schemes
    return scheme === "http:" || scheme === "https:";
  } catch {
    return false;
  }
};

const Success = () => {
  const { orgID } = useParams();
  const location = useLocation();
  // useLocation doesn't provide generic typing so we can define it as such here
  const state = location.state as LocationState;

  if (state?.redirectUrl && isValidRedirectUrl(state.redirectUrl)) {
    // need to use ?? "" here for type complaints even though the empty string will never get sent because of the if check
    setTimeout(() => window.location.replace(state.redirectUrl ?? ""), REDIRECT_SECONDS * 1000);
  }

  return (
    <>
      <div className="flex min-h-full flex-col bg-white pt-16 pb-12">
        <main
          className="
            mx-auto flex w-full max-w-7xl grow flex-col justify-center px-4
            sm:px-6
            lg:px-8
          "
        >
          <div className="flex shrink-0 justify-center">
            <span className="sr-only">Success!</span>
            <div className="inline-flex w-48 shrink-0 items-center justify-center rounded-lg">
              <BrandedLogo orgID={orgID} />
            </div>
          </div>
          <div className="py-20">
            <div className="mx-auto flex size-24 items-center justify-center rounded-full bg-emerald-100">
              <CheckIcon className="size-12 text-emerald-600" aria-hidden="true" />
            </div>
            <div className="text-center">
              <h1
                className="
                  mt-4 text-4xl font-extrabold tracking-tight text-gray-900
                  sm:text-5xl
                "
              >
                Success!
              </h1>
              <p className="mt-2 text-base text-gray-500">You have successfully submitted your destination.</p>
              {state?.redirectUrl && isValidRedirectUrl(state.redirectUrl) && (
                <p className="mt-2 text-sm text-gray-500">
                  You will be redirected in {REDIRECT_SECONDS} seconds. Click{" "}
                  <span
                    className="
                      text-emerald-500
                      hover:text-emerald-700
                    "
                  >
                    <a href={state?.redirectUrl}>here</a>
                  </span>{" "}
                  to redirect now.
                </p>
              )}
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default Success;
